import styled from 'styled-components';
import Box from '@rsos/base-components/Box';

const WIDTH = 216;
const HEIGHT = 55;
const CARET_OFFSET = 30;
const GOOGLE_INFOWINDOW_BG = '#fff';

export const StyledPopover = styled(Box)`
  width: ${WIDTH}px;
  height: auto;
  position: absolute;
  padding: 10px;
  background: ${GOOGLE_INFOWINDOW_BG};
  color: black;
  font-weight: lighter;
  border-radius: 5px;
  top: ${({ y }) => `${(y || 0) - HEIGHT - CARET_OFFSET}px`};
  left: ${({ x }) => `${(x || 0) - 0.5 * WIDTH}px`};
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.3);
  z-index: 1; // Needs a z-index > 0 for Google maps
`;

export const StyledPopoverCaret = styled(Box)`
  // the box around the caret and shadow
  width: 80px;
  height: 14px;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;

  // the caret is a square rotated 45 degrees
  &::after {
    content: '';
    position: absolute;
    width: 14px;
    height: 14px;
    background: ${GOOGLE_INFOWINDOW_BG};
    transform: translateX(-50%) translateY(-50%) rotate(45deg);
    top: 0;
    left: 50%;
    box-shadow: 1px 1px 20px 0px rgba(0, 0, 0, 0.3);
  }
`;
